import { NotifyHelper } from "../../../helpers/toast";
import { eDanhSachMienGiamActionsObj } from "../../action-types/mien-giam/IDanhSachMienGiamActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const danhSachMienGiamActions = {
  ...generateActions(eDanhSachMienGiamActionsObj, "DANH_SACH_MIEN_GIAM"),
  ...generateActionForKey(
    eDanhSachMienGiamActionsObj,
    "DANH_SACH_MIEN_GIAM",
    "DUYET_SUCCESS",
    () => {
      NotifyHelper.Success("Duyệt thành công");
    }
  ),
  ...generateActionForKey(
    eDanhSachMienGiamActionsObj,
    "DANH_SACH_MIEN_GIAM",
    "HUY_DUYET_SUCCESS",
    () => {
      NotifyHelper.Success("Hủy duyệt thành công");
    }
  ),
};
